export default __webpack_public_path__ + "fonts/tax-delinquency.svg";